import {type PublicDialogProps, SelectPickerDialog} from '@github-ui/filter-picker'

import {useDefaultReposProviders} from './hooks/use-query-definitions'
import {getReposItemConfig} from './ItemConfig'
import type {MultiSelectReposProps} from './types'

type MultiSelectReposPickerDialogProps = MultiSelectReposProps & PublicDialogProps

export function MultiSelectReposPickerDialog({scope, ...props}: MultiSelectReposPickerDialogProps) {
  const itemConfig = getReposItemConfig(scope)
  const providers = useDefaultReposProviders(scope)

  return (
    <SelectPickerDialog
      {...props}
      title="Select repositories"
      selectionVariant="multiple"
      providers={providers}
      itemConfig={itemConfig}
    />
  )
}

try{ MultiSelectReposPickerDialog.displayName ||= 'MultiSelectReposPickerDialog' } catch {}